import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={22} height={22} fill="none" {...props}>
    <Path
      stroke="#C0A46F"
      strokeLinecap="round"
      d="M11.093 21c2.662-1.15 8.317-5.01 9.643-11.261 1.657-7.814-4.822-10.725-9.643-7.355-4.821 3.371-2.185 13.33 3.465 16.165"
    />
    <Path
      stroke="#C0A46F"
      strokeLinecap="round"
      d="M11.105 21C8.39 19.85 2.622 15.99 1.27 9.739-.421 1.925 6.187-.986 11.105 2.384c4.918 3.371 2.229 13.33-3.534 16.165"
    />
  </Svg>
);
export default SvgComponent;
